var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('CommonBanner',{attrs:{"content":_vm.content}}),_c('SideProducts',{staticClass:"products-wrap",attrs:{"sides":_vm.sides}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }